import React from 'react';
import {Input, RemoveButton, RequiredButton} from '../../ui';
import {setFields} from '../../service/createForm.slice';
import {useDispatch} from 'react-redux';
import {useRemoveField, useToggleRequired} from '../../model';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function SumpSampleNA({field, idx}) {
  const dispatch = useDispatch();
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);
  const {removeField} = useRemoveField();
  const {toggleRequired} = useToggleRequired();
  const {t} = useTranslation();
  const handleRequired = () => toggleRequired(idx);
  const handleChange = e => {
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };

  const handleRemove = () => removeField(idx);

  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          value={'Sump Sample With N/A'}
          disabled={true}
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'condition-remove'}
              idx={idx}
              id={'condition'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-options'>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.cleanBright')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.other')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.notApplicable')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.notUsed')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.clean')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.slight')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.particulate')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.dirty')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.bright')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
                {t('createNewForm.components.hazy')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.cloudy')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.wet')}
        </div>
        <div className='f-build__general-option_radio'>
          <div className='f-build__general-option_input'></div>
          {t('createNewForm.components.surfactants')}
        </div>
      </div>
    </div>
  );
}

export default SumpSampleNA;
